import React, { useState, useEffect } from 'react';

import { get } from '@api/v4/resources/conversion_presets';

import PresetForm from './preset_form';
import PresetTable from './preset_table';

import './styles/cropping.scss';

export default () => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const isCollection = Boolean(BF.fx.collection().key);
  const resourceType = isCollection ? 'collection' : 'brandfolder';
  const resourceFunc = isCollection ? BF.fx.collection : BF.fx.brandfolder;
  const { key, name: resourceName } = resourceFunc();

  const fetchPresets = async () => {
    setItems(await get({
      resourceType,
      resourceKey: key,
    }));
  };

  useEffect(() => {
    fetchPresets();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filteredItems = items.filter(({ name }) => name.includes(search));

  return (
    <div className="cropping">
      <h2>{bfTranslate("Download Presets for")} {resourceName}</h2>
      <hr />
      <PresetForm
        onAddPreset={fetchPresets}
        resourceKey={key}
        resourceType={resourceType}
      />
      <input
        className="bf-input searchbar"
        onChange={({ target }) => setSearch(target.value)}
        placeholder={bfTranslate("Search for download presets")}
        type="text"
        value={search}
      />
      <PresetTable
        items={filteredItems}
        onPresetChange={fetchPresets}
      />
    </div>
  );
};
